import { render } from "./MerchantProfileFormNew.vue?vue&type=template&id=85f1d03c"
import script from "./MerchantProfileFormNew.vue?vue&type=script&lang=js"
export * from "./MerchantProfileFormNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__